export default {
  amount: '预计存款金额',
  customer: '客户姓名',
  number: '客户账号',
  children_account: '银行子账号', // 补充
  accountMaster: '艾德证券期货有限公司',
  noSub: '无子账户申请记录',
  success: '您的子账户申请已成功提交，如有问题请与我们联系',
  detailsTitle: '银行子账户详情',
  detailsBankName: '开户银行',
  detailsBankCardNumber: '银行卡号',
  detailsPayeeName: '收款人姓名',
  detailsSwiftCode: 'SWIFT 代码',
  detailsBankAddress: '银行地址',
  detailsAliasAddress: '银行英文地址',
  notCHN: '您好，该页面无法查看！谢谢。'
}
